import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();
const ON_KEY = 'mv-ai-on'

const readCache = () => {
    try { return sessionStorage.getItem(ON_KEY) === 'true' } catch (e) { return false }
}

const writeCache = (on) => {
    try { sessionStorage.setItem(ON_KEY, String(on)) } catch (e) { /* private mode: just ask again */ }
}

// AI Help (shoppers only; staff would get 403, which signs them out, so only call it for shoppers).
// The conversation lives in the browser; the server stores no chat text.
class AiService {

    status() {
        return axiosInstance().get(path + "/ai/status");
    }

    // messages: [{ role: 'user' | 'assistant', text }], newest last
    chat(messages, declaration) {
        return axiosInstance().post(path + "/ai/chat", { messages, declaration });
    }

    confirm(actionId) {
        return axiosInstance().post(path + "/ai/actions/" + encodeURIComponent(actionId) + "/confirm");
    }

    cancel(actionId) {
        return axiosInstance().post(path + "/ai/actions/" + encodeURIComponent(actionId) + "/cancel");
    }

    // whether to show AI Help in the header and menu (remembered for the tab session)
    cachedEnabled() {
        return readCache()
    }

    enabled() {
        return this.status()
            .then(res => {
                const on = !!(res.data && res.data.data && res.data.data.enabled)
                writeCache(on)
                return on
            })
            .catch(() => readCache())
    }

    remember(on) {
        writeCache(on)
    }
}

export default new AiService()
